import amo from './amo';
import bagatelo from './bagatelo';
import greensleeves from './greensleeves';
import irlandaKanteto from './irlanda_kanteto';
import miMultekoloras from './mi_multekoloras';
import noname2 from './noname2';
import printempo from './printempo';
import promenadoTraLaUrbo from './promenado_tra_la_urbo';
import verdaTeo from './verda_teo';
import miMalverdas from './mi_malverdas';

const verkoj = [
  verdaTeo,
  miMultekoloras,
  amo,
  bagatelo,
  greensleeves,
  irlandaKanteto,
  printempo,
  promenadoTraLaUrbo,
  noname2,
  miMalverdas
];

export default verkoj;